import { AuthActionTypeEnum } from "./AuthActionTypeEnum";
import { DeleteInstallationsAuthActionResponse } from "./DeleteInstallations/DeleteInstallationsAuthActionResponse";

export abstract class AuthActionResponse {
    readonly type: AuthActionTypeEnum;
    expirationDate: Date;

    /** Deserializza la risposta (Type e ExpirationDate) e i relativi parametri (Params) a partire da un oggetto non parsato in ts. Restituisce una AuthActionResponse o null. Gestire eventuali eccezioni.*/
    public static deserialize(responseContent: any): AuthActionResponse {
        let response = responseContent.AuthorizedActionResponse;
        console.debug("AuthResponse.deserialize() - response: ", response);

        if (response && response.attrs) {
            let currentActionType: AuthActionTypeEnum = AuthActionTypeEnum[response.attrs.type as keyof typeof AuthActionTypeEnum];
            let expirationDate = response.attrs.expiration;
            switch (currentActionType) {
                case AuthActionTypeEnum.DeleteInstallations:
                    return new DeleteInstallationsAuthActionResponse(expirationDate, response.Params);
                default:
                    break;
            }
        }
        return null;
    }
}
